export default "__VITE_ASSET__Cb9K$B$N__"